import { useClient, useDictionary } from "@adamlip/okeoke.client"
import { Button, Card, CardBody, CardFooter, Image } from "@nextui-org/react"
import moment from "moment"
import LoadSvg from "utils/LoadSvg-v3"

function CouponCard({
  coupon,
  handleClaimCoupon,
  openCouponModal,
  activateInProgress,
  appParams,
  mode,
  handleActivateCoupon,
  handleDeActivateCoupon,
}) {
  const { getValue } = useDictionary()
  const { getName } = useClient()

  return (
    <Card
      shadow="sm"
      key={coupon.id}
      className="flex flex-col bg-[var(--coupon-bg)] text-[var(--coupon-text)] md:shrink-0 md:min-w-[300px] md:max-w-[300px]"
    >
      <CardBody>
        {coupon?.attributes?.imageUrl != null && (
          <div className="w-[400px] max-w-full p-1 m-auto">
            <div className="aspect-ratio">
              <Image
                src={coupon?.attributes?.imageUrl}
                className="mb-2 w-full h-full z-0"
                classNames={{
                  img: "object-cover",
                  wrapper:
                    "!absolute overflow-hidden w-full h-full rounded-md bg-[var(--coupon-imageBg)] !max-w-full",
                }}
              />
            </div>
          </div>
        )}
        <div className="flex flex-col ">
          <div className="w-full text-lg font-bold text-[var(--coupon-nameText)]">
            {coupon?.label != null ? getName(coupon?.label) : coupon?.name}
          </div>
          <div className="gap-1 flex flex-col">
            <div className="w-full line-clamp-3 text-sm mt-2 font-light">
              {getName(coupon?.description) ||
                getValue("app_v2_coupons_noDescription")}
            </div>
            <div className="flex flex-row items-center font-light justify-start gap-1 text-sm">
              <div className="label">
                {getValue("app_v2_coupons_couponAvailable")}:
              </div>
              <div className="value">
                {moment(coupon.endDate).format("YYYY.MM.DD")}
              </div>
            </div>
            {coupon?.stores != null && (
              <>
                <div className="flex flex-row gap-1 items-center justify-start text-sm">
                  <LoadSvg name="setLocation" />
                  <div className="count">{(coupon?.stores || []).length}</div>
                  <div className="text">
                    {getValue("app_v2_coupons_storesAvailable")}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </CardBody>
      <CardFooter className="flex w-full justify-between">
        <Button
          color="secondary"
          className="bg-[var(--coupon-detailsBg)] text-[var(--coupon-detailsText)]"
          size="sm"
          onClick={() => openCouponModal(coupon)}
        >
          {getValue("app_v2_coupons_goToDetails")}
        </Button>
        {mode === "all" && (
          <Button
            color="primary"
            className={`bg-[var(--coupon-claimBg)] text-[var(--coupon-claimText)] font-bold ${appParams?.styles?.fonts?.capitalize ? "uppercase" : ""
              }`}
            size="sm"
            onClick={() => handleClaimCoupon(coupon)}
            isLoading={activateInProgress === coupon?.code}
          >
            {coupon.isClaimed
              ? getValue("app_v2_coupons_claimed")
              : getValue("app_v2_coupons_not_claimed")}
          </Button>
        )}
        {mode === "claimed" && (
          <Button
            color="primary"
            className={`bg-[var(--coupon-claimBg)] text-[var(--coupon-claimText)] ${appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
              }`}
            size="sm"
            onClick={() => handleActivateCoupon(coupon)}
            isLoading={activateInProgress === coupon?.code}
          >
            {coupon.active
              ? getValue("app_v2_coupons_active")
              : getValue("app_v2_coupons_activate")}
          </Button>
        )}
        {mode === "active" && (
          <Button
            color="primary"
            className={`bg-[var(--coupon-claimBg)] text-[var(--coupon-claimText)] ${appParams?.styles?.fonts?.capitalize ? "font-bold uppercase" : ""
              }`}
            size="sm"
            onClick={() => handleDeActivateCoupon(coupon)}
            isLoading={activateInProgress === coupon?.code}
          >
            {coupon.active
              ? getValue("app_v2_coupons_deactivate")
              : getValue("app_v2_coupons_activate")}
          </Button>
        )}
      </CardFooter>
    </Card>
  )
}

export default CouponCard
